module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_21.4e92a474.pdf";